<template>
  <div class="error">
    <div class="error-empty">
      <div class="error-empty-img">
        <img src="../assets/image/no-result.png" alt="" />
        <div class="error-empty-content" v-if="error">
          <p>404</p>
          <div class="error-empty-content-text">抱歉！您的页面走丢了~</div>
        </div>
      </div>
      <div class="error-empty-renew">
        <lr-link to="/learning/">返回首页</lr-link>
      </div>
    </div>
  </div>
</template>
<script>

export default {
    props: {
        error: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    head() {
        const header = this.$head.defaultHead();
        return header;
    },
    mounted() {
      // 特殊处理首页异常的404，如果首页出现异常，则还原首页navbar样式
      if (this.$nuxt.$route.name === 'home') {
        this.$eventBus.$emit('@check_navbar_in_default_height', {
          isNavStyleChange: false,
          isNavSearchShow: true,
        })
      }
    }
};
</script>
<style lang="scss">
.error {
  width: 1110px;
  margin: 0 auto;
  margin-top: 10px;

  &-empty {
    width: 720px;
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 100px;
    text-align: center;

    &-img{
      > img{
        width: 144px;
        height: 100px;
      }
    }

    &-content {
      p {
        font-size: 28px;
        font-weight: bold;
        color: #222226;
      }
    }
    &-content-text {
      margin-top: 10px;
      margin-bottom: 20px;
      font-size: 12px;
      color: #999999;
    }

    &-renew {
      border: none;
      width: 197px;
      line-height: 34px;
      outline: none;
      background-color: #417ff9;
      border-radius: 17px;
      display: inline-block;

      > a {
        background-color: #417ff9;
        display: inline-block;
        border-radius: 17px;
        border: none;
        width: 100%;
        line-height: 34px;
        outline: none;
        font-size: 14px;
        color: #ffffff;

        &:hover {
          color: #ffffff;
          background-color: #5d92f9;
        }
      }
    }
  }
}
</style>
